import { useEffect } from "react";
import { Link } from "react-router-dom";
import {AiFillFacebook} from 'react-icons/ai';
import {AiFillInstagram} from 'react-icons/ai';
import {AiFillTwitterSquare} from 'react-icons/ai';
import { FaTiktok } from "react-icons/fa";
import {FaWhatsappSquare} from 'react-icons/fa';
import YearDateUpdate from "./YearDateUpdate";
import Logo from "../images/pest_ex_logo_e.png";
import './footer.css';

const Footer = () => {
    return (
        <div className="footer">
            <div className="container footer_container">
                <div className="footer_details_cont">
                    <div className="footer_detail footer_detail_one">
                        <div className="footer_logo">
                            <Link to="/">
                                <img src={Logo} className="footer-logo"/>
                            </Link>
                        </div>
                        <div className="footer_about">
                            <p>
                                At PestEX Masters, we understand the impact that pests can have on your home or
                                business. Pests such as termites, rodents, bedbugs, and cockroaches can cause extensive damage to
                                property and pose health risks to your family, employees, and customers.
                            </p>
                        </div>
                    </div>
                    <div className="footer_detail footer_detail_two">
                        <h3>Quick Links</h3>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/about">About</Link></li>
                            <li><Link to="/services">Services</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                    <div className="footer_detail footer_detail_two">
                        <h3>Business Hours</h3>
                        <ul>
                            <li>Monday - Friday: 8:00 am - 5:00 pm</li>
                            <li>Saturday: 9:00 am - 4:00 pm</li>
                            <li>Sunday: Closed</li>
                        </ul>
                    </div>
                    <div className="footer_detail footer_detail_three">
                        <h3>Get In Touch</h3>
                        <ul>
                            <li>
                                <p>P.O. Box 0000 - 00200, Nairobi</p>
                            </li>
                            <li>
                                <p>
                                    info@pestexmasters.co.ke
                                </p>
                            </li>
                            <li>
                                <p>
                                    (+254)-708-746-461
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="footer_copyright_cont">
                    <div className="copyright">
                        <p>©<YearDateUpdate/> PestEX Masters. All Rights Reserved.</p>
                    </div>
                    <div className="footer_socials">
                        <ul>
                            <li><Link to="#" target="_blank"><AiFillFacebook/></Link></li>
                            <li><Link to="https://www.instagram.com/@pestexke" target="_blank"><AiFillInstagram/></Link></li>
                            <li><Link to="https://x.com/pestexke" target="_blank"><AiFillTwitterSquare/></Link></li>
                            <li><Link to="https://www.tiktok.com/@pestexke" target="_blank"><FaTiktok/></Link></li>
                            <li><Link to="https://wa.link/d9n8np" target="_blank"><FaWhatsappSquare/></Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer